import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-pm-wishlist-filter',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule
  ],
  templateUrl: './pm-wishlist-filter.component.html',
  styleUrl: './pm-wishlist-filter.component.scss'
})
export class PmWishlistFilterComponent {

  appliedFilters={
    dikshyarthiName:'',
    address:'',
    isVisited:-1,
    isReached:-1

  }
  
  constructor(
     @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef:MatDialogRef<PmWishlistFilterComponent>
  ){
     this.appliedFilters = {
      dikshyarthiName: data?.appliedFilters?.dikshyarthiName ?? '',
      address: data?.appliedFilters?.address ?? '',
      isVisited: data?.appliedFilters?.isVisited ?? -1,
      isReached: data?.appliedFilters?.isReached ?? -1
    };
  }
  applyFilter(){
    let filters=Object.fromEntries(Object.entries(this.appliedFilters).filter(([key,value])=>value!==-1&&value!==''));
    this.dialogRef.close(filters);
  }
}
